import commentifyTypes from './types';

export const initialStates = {
	newComments: null,
	reply: null,
	isLoading: false,
};

const commentsReducers = (state = initialStates, action) => {
	switch (action.type) {
		case commentifyTypes.NEWEST_COMMENTS.REQUEST: {
			return { ...state, isLoading: true };
		}
		case commentifyTypes.NEWEST_COMMENTS.FAILURE: {
			return { ...state, isLoading: false };
		}
		case commentifyTypes.NEWEST_COMMENTS.SUCCESS: {
			return { ...state, newComments: action?.payload, isLoading: false };
		}

		case commentifyTypes.REPLY.SUCCESS: {
			return { ...state, reply: action?.payload };
		}

		case commentifyTypes.REPLY.CLEAR: {
			return { ...state, reply: null };
		}

		default:
			return state;
	}
};

export default commentsReducers;
